import { ResponseMessage } from './Notification';
import { OperationFile } from './OperationFile';

export class ApiResponseModel {

    public responseMessages: Array<ResponseMessage>;
    public messageCode: string;
    public message: string;
    public exceptionMessage: string;
    public messageType: string;
    public statusCode: number;
    public data: Object;
    public filesData: Array<OperationFile>;

    constructor(obj: any = null) {
        if (obj)
            Object.assign(this, obj);
    }
}

export class TypedApiResponseModel<T extends Object> {

    public responseMessages: Array<ResponseMessage>;
    public messageCode: string;
    public message: string;
    public exceptionMessage: string;
    public messageType: string;
    public statusCode: number;
    public data: T;
    public filesData: Array<OperationFile>;

    constructor(obj: any = null) {
        if (obj)
            Object.assign(this, obj);
    }
}